import { useRef, useState } from 'react';
import { IoIosAttach } from "react-icons/io";

const UploadAssetButton = ({ kind, className, label, onFileUploaded }) => {

  const inputRef = useRef(null);
  const [fileName, setFileName] = useState(null);


  const accept = kind === 'image'
    ? 'image/*'
    : 'audio/mpeg,audio/mp3,audio/*';

  const pick = () => inputRef.current?.click();

  function handleFileUpload(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFileName(file.name);
      onFileUploaded(file);

    }
  }

  return (
    <div className="d-inline-flex align-items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        hidden
        onChange={handleFileUpload}
      />
      <button type="button" className={className} onClick={pick}>
        <IoIosAttach />{label}
      </button>
      <div>
        {fileName != null && <small className="text-muted">{fileName}</small>}
      </div>
    </div>
  );
}

export default UploadAssetButton